import { analyzeFullSite as analyzeFullSiteReq } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { ExecutionProfile } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/types';
export const analyzeFullSite = async (httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const response = await withErrorHandler(async () => httpClient.request(analyzeFullSiteReq({
    options: {
      executionProfile: ExecutionProfile.EXECUTION_PROFILE_A11Y
    }
  })), {
    errorCodesMap: {}
  });
  return response;
};
//# sourceMappingURL=analyze-full-site.js.map